import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import Button from "@/components/Button";
import EndCompetitionModal from "./EndCompetitionModal";

const StyledButton = styled(Button)`
  height: 38px;
  padding: 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-right: 16px;
`;

interface Props {
  competition: {
    id: number;
    ended_at?: string;
  };
}

const EndCompetitionButton: FC<Props> = ({ competition }) => {
  const [showCompetitionModal, setShowCompetitionModal] = useState(false);

  return (
    <>
      <StyledButton
        onClick={() => setShowCompetitionModal(true)}
        color="secondary"
      >
        End competition
      </StyledButton>
      <AnimatePresence>
        {showCompetitionModal && (
          <EndCompetitionModal
            competition={competition}
            onClose={() => setShowCompetitionModal(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default EndCompetitionButton;
